import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaGraduationCap } from 'react-icons/fa';
import UniversityFooter from '../../components/UniversityFooter/UniversityFooter';
import './UniversityLegal.css';

const UniversityPrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="uni-legal-page">
      <header className="uni-legal-header">
        <button className="uni-legal-back" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back
        </button>
        <div className="uni-legal-header-brand">
          <FaGraduationCap /> ULSAAPP University
        </div>
      </header>

      <main className="uni-legal-main">
        <h1>Privacy Policy</h1>
        <p className="uni-legal-updated">Last updated: May 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            ULSAAPP University ("we", "us", "our") is committed to protecting the privacy of
            all users of our Virtual University platform. This Privacy Policy explains how we
            collect, use, store, and protect your personal information when you use our
            AI-powered evaluation and certification system.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <h3>2.1 Account Information</h3>
          <p>
            When you register, we collect your name, email address, and profile picture
            (if provided or obtained via Google sign-in). We use this information to
            identify your account and personalize your experience.
          </p>
          <h3>2.2 Academic Data</h3>
          <p>
            We collect the subjects you select, your exam responses, scores, results,
            analytics data, certificates earned, and exam history. This data powers your
            personalized dashboard, progress tracking, and certificate generation.
          </p>
          <h3>2.3 Usage Data</h3>
          <p>
            We automatically collect information about how you interact with the platform,
            including pages visited, features used, exam session behaviour (such as tab
            switch counts during exams), device type, browser, and IP address.
          </p>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To generate AI-powered exam questions tailored to your chosen subjects and level.</li>
            <li>To evaluate your exam answers using AI — no manual interference in grading.</li>
            <li>To issue certificates when you meet the passing criteria.</li>
            <li>To provide analytics, performance insights, and AI-generated feedback.</li>
            <li>To send notifications about exam results, alerts, and platform updates.</li>
            <li>To improve the platform experience and AI accuracy.</li>
          </ul>
        </section>

        <section>
          <h2>4. AI Processing</h2>
          <p>
            ULSAAPP University uses artificial intelligence to generate exam questions and
            evaluate your answers. Your responses are processed by AI systems for scoring
            and feedback. No human manually reviews or grades individual exam submissions.
          </p>
        </section>

        <section>
          <h2>5. Data Sharing</h2>
          <p>
            We do not sell your personal information. We may share data with third-party
            service providers (hosting, AI services, analytics) strictly to operate the
            platform. We may also disclose information when required by law.
          </p>
        </section>

        <section>
          <h2>6. Data Security</h2>
          <p>
            We implement reasonable technical and organizational measures to protect your
            data against unauthorized access, alteration, or destruction. However, no
            method of internet transmission is 100% secure.
          </p>
        </section>

        <section>
          <h2>7. Data Retention</h2>
          <p>
            We retain your account and academic data for as long as your account is active.
            Exam results and certificates are retained indefinitely to support your
            academic record. You may request account deletion by contacting us.
          </p>
        </section>

        <section>
          <h2>8. Your Rights</h2>
          <ul>
            <li>Access, correct, or delete your personal information.</li>
            <li>Request a copy of your data.</li>
            <li>Withdraw consent for optional data processing.</li>
            <li>Lodge a complaint with a data protection authority.</li>
          </ul>
        </section>

        <section>
          <h2>9. Cookies</h2>
          <p>
            We use cookies and local storage to maintain your session, remember theme
            preferences, and improve performance. You can manage cookie settings through
            your browser.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically. Changes will be posted on this
            page with an updated revision date. Continued use of the platform after changes
            constitutes acceptance.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, contact us at{' '}
            <a href="mailto:support.ulsaapp@atozasindia.in">support.ulsaapp@atozasindia.in</a>.
          </p>
        </section>
      </main>

      <UniversityFooter />
    </div>
  );
};

export default UniversityPrivacyPolicy;
